import { Suspense, lazy } from 'react'
// components
import LoadingScreen from '../components/loading-screen'

// ----------------------------------------------------------------------

const Loadable = (Component) => (props) =>
  (
    <Suspense fallback={<LoadingScreen />}>
      <Component {...props} />
    </Suspense>
  )

// ----------------------------------------------------------------------

// AUTH
export const LoginPage = Loadable(lazy(() => import('../pages/auth/LoginPage')))
export const NewPasswordPage = Loadable(lazy(() => import('../pages/auth/NewPasswordPage')))
export const ResetPasswordPage = Loadable(lazy(() => import('../pages/auth/ResetPasswordPage')))
export const OperatorLoginPage = Loadable(lazy(() => import('../pages/auth/operator/login')))

// TRACK
export const TrackEventsPage = Loadable(lazy(() => import('../pages/dashboard/track/EventsPage')))
export const TrackCategoriesPage = Loadable(
  lazy(() => import('../pages/dashboard/track/CategoriesPage'))
)
export const PublicEventsPage = Loadable(lazy(() => import('../pages/public/EventsPage')))
export const PublicCategoriesPage = Loadable(lazy(() => import('../pages/public/CategoriesPage')))
export const TrackPanelPage = Loadable(lazy(() => import('../pages/dashboard/track/PanelPage')))
export const TrackPublicPanelPage = Loadable(
  lazy(() => import('../pages/dashboard/track/PublicPanelPage'))
)
export const TrackAuditPage = Loadable(lazy(() => import('../pages/dashboard/track/AuditPage')))
export const TrackReportsPage = Loadable(lazy(() => import('../pages/dashboard/track/ReportsPage')))

// MAIN ERROR / STATICS
export const Page500 = Loadable(lazy(() => import('../pages/Page500')))
export const Page403 = Loadable(lazy(() => import('../pages/Page403')))
export const Page404 = Loadable(lazy(() => import('../pages/Page404')))
export const ComingSoonPage = Loadable(lazy(() => import('../pages/ComingSoonPage')))
export const MaintenancePage = Loadable(lazy(() => import('../pages/MaintenancePage')))
